import {
  ACCOUNT_CHANGING_PASSWORD_LINK,
  HOME_PAGE_LINK,
  ACCOUNT_CHANGING_INFO_LINK,
  MY_PROFILE_PAGE_LINK,
  NOT_FOUND_PAGE_LINK,
  ROLES_PAGE_LINK,
  SIGN_UP_LINK,
  CLIENT_SIGN_UP_LINK,
  CLIENT_FORGOT_PASSWORD_LINK,
  CLIENT_RESET_PASSWORD_PAGE_LINK,
  USERS_PAGE_LINK,
  FORGOT_PASSWORD_PAGE_LINK,
  RESET_PASSWORD_PAGE_LINK,
  TENANTS_PAGE_LINK,
  REGISTER_NOTIFY_VERIFY_EMAIL_LINK,
  CLIENT_REGISTER_NOTIFY_VERIFY_EMAIL_LINK,
} from 'commons/constants';
import Loadable from 'react-loadable';
import ClientSignUpPage from '../pages/ClientSignUpPage';
import ClientForgotPasswordPage from '../pages/ClientForgotPasswordPage';

const LoadableLoading = () => <></>;
const loadable = (
  loader: () => Promise<React.ComponentType<any> | { default: React.ComponentType<any> }>
) =>
  Loadable({
    loader,
    delay: false,
    loading: LoadableLoading,
  });

export default {
  // default pages
  [NOT_FOUND_PAGE_LINK]: {
    component: loadable(() => import('../pages/NotFoundPage')),
    requiredAuth: true,
  },

  // my profile [START]
  [ACCOUNT_CHANGING_INFO_LINK]: {
    component: loadable(() => import('../pages/MyProfilePage/ChangingInfoPage')),
    requiredAuth: true,
  },
  [ACCOUNT_CHANGING_PASSWORD_LINK]: {
    component: loadable(() => import('../pages/MyProfilePage/ChangingPasswordPage')),
    requiredAuth: true,
  },
  [MY_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/MyProfilePage')),
    requiredAuth: true,
  },
  // my profile [END]

  // users page
  [USERS_PAGE_LINK]: {
    component: loadable(() => import('../pages/UserManagement')),
    requiredAuth: true,
  },

  // roles page
  [ROLES_PAGE_LINK]: {
    component: loadable(() => import('../pages/RoleManagement')),
    requiredAuth: true,
  },
  // notify verify email
  [REGISTER_NOTIFY_VERIFY_EMAIL_LINK]: {
    component: loadable(() => import('../pages/RegisterNotifyVerifyEmail')),
    singlePage: true,
    requiredAuth: false,
  },
  // client notify verify email
  [CLIENT_REGISTER_NOTIFY_VERIFY_EMAIL_LINK]: {
    component: loadable(() => import('../pages/ClientRegisterNotifyVerifyEmail')),
    singlePage: true,
    requiredAuth: false,
  },
  // sign-up page
  [SIGN_UP_LINK]: {
    component: loadable(() => import('../pages/SignUpPage')),
    singlePage: true,
    requiredAuth: false,
  },
  // client sign-up page (OAuth2 client flow)
  [CLIENT_SIGN_UP_LINK]: {
    component: ClientSignUpPage,
    singlePage: true,
    requiredAuth: false,
  },
  // client forgot password page (OAuth2 client flow)
  [CLIENT_FORGOT_PASSWORD_LINK]: {
    component: ClientForgotPasswordPage,
    singlePage: true,
    requiredAuth: false,
  },
  // client reset password page (OAuth2 client flow)
  [CLIENT_RESET_PASSWORD_PAGE_LINK]: {
    component: loadable(() => import('../pages/ClientResetPassword')),
    singlePage: true,
    requiredAuth: false,
  },

  // forgot password page
  [FORGOT_PASSWORD_PAGE_LINK]: {
    component: loadable(() => import('../pages/ForgotPassword')),
    singlePage: true,
    requiredAuth: false,
  },

  // reset password page
  [RESET_PASSWORD_PAGE_LINK]: {
    component: loadable(() => import('../pages/ResetPassword')),
    singlePage: true,
    requiredAuth: false,
  },
  // tenant page
  [TENANTS_PAGE_LINK]: {
    component: loadable(() => import('../pages/TenantManagement')),
    requiredAuth: true,
  },
  // home page
  [HOME_PAGE_LINK]: {
    component: loadable(() => import('../pages/MyProfilePage')),
    requiredAuth: true,
  },
};
